<ng-container *transloco="let t; prefix:'customers.customersDetail'">
    <h2 mat-dialog-title class="dialog-header">
        <span class="dialog-title title-large">Dettagli indirizzo</span>

        <button
            mat-icon-button
            type="button"
            aria-label="Chiudi"
            class="close-button"
            (click)="onClose()"
        >
            <i class="fa-regular fa-xmark"></i>
        </button>
    </h2>

    <mat-dialog-content class="content">
        <div class="section-header">
            <span class="title-large-emphasized">Destini di consegna</span>

            <button
                matIconButton
                type="button"
                aria-label="Modifica destino di consegna"
                (click)="openEditDialog()"
            >
                <i class="fa-regular fa-pencil"></i>
            </button>
        </div>

        <div class="details-card">
            <div class="details-card-content">
                @for (field of mainFields; track field.key) {
                    <div class="details-card-field">
                        <span class="body-small">{{ field.label }}</span>
                        <span class="body-small-emphasized">{{ field.key === 'missing' ? '-' : (data[field.key] || '-') }}</span>
                    </div>
                }
            </div>
        </div>

        <span class="title-large-emphasized">Note</span>

        <div class="details-card">
            <div class="details-card-content">
                @for (field of noteFields; track field.key) {
                    <div class="details-card-field">
                        <span class="body-small">{{ field.label }}</span>
                        @if (field.key === 'sponda') {
                            <span class="body-small-emphasized">
                                {{ data.nota.sponda === true ? t('common.yes') : t('common.no') }}
                            </span>
                        } @else {
                            <span class="body-small-emphasized">{{ data.nota[field.key] || '-' }}</span>
                        }
                    </div>
                }
            </div>
        </div>
    </mat-dialog-content>
</ng-container>
